import React, { useState } from "react";
import "./ForgetPassword.css";
import { useDispatch } from "react-redux";
import { setActiveComponent } from "../../../Redux/Slices/activeComponentSlice";
import OtpVerification from "../OtpVerification/OtpVerification";
import { forgetPassword } from "../../../api/auth";
import { tokenStorage } from "../../../api/index";
import Loader from "../../Loader";

function ForgetPassword() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSendInstructionClick = async (event) => {
    if (isLoading) return;
    setIsLoading(true);
    event.preventDefault();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      setIsLoading(false);
      return;
    }
    try {
      const data = await forgetPassword({ email });
      console.log(" response from forget password api:", data);
      tokenStorage.setToken(data.token);
      dispatch(setActiveComponent("otpVerification"));
    } catch (error) {
      setEmailError("Email not found");
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleBackToSignInClick = () => {
    dispatch(setActiveComponent("signIn"));
  };

  const handleEmailInputChange = (e) => {
    setEmail(e.target.value);
    setEmailError("");
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendInstructionClick(e);
    }
  };

  return (
    <div className="ForgetPassword">
      <div className="forgetPasswordContainer1">
        <span className="signInText">Forget your password</span>
        <div className="forgetPasswordText2Container">
          <span className="signInText2">
            Enter the email address you used when you joined
          </span>
          <span className="signInText2">
            and we'll send you instructions to reset your
          </span>
          <span className="signInText2">password</span>
        </div>
        <div className="generalInputContainer">
            <label htmlFor="emailInput" className="labelText">
              Email
            </label>
            <div className="inputContainerWrapper">
            <input
              id="emailInput"
              className="input"
              type="text"
              placeholder="Type your e-mail"
              value={email}
              onChange={(e) => {
                handleEmailInputChange(e);
              }}
              onKeyDown={handleKeyPress}
            />
          {emailError && (
            <span className="errorTooltip">{emailError}</span>
          )}
          </div>
        </div>
        <button 
          className="btnContainer" 
          onClick={handleSendInstructionClick}
          disabled={isLoading}
        >
          {isLoading ? <Loader /> : <span className="btnText">Send Reset Instruction</span>}
        </button>
        <span className="backToSignInText" onClick={handleBackToSignInClick}>
          Back To Sign in
        </span>
      </div>
    </div>
  );
}

export default ForgetPassword;
